// Currency formatting utility
const CURRENCY_MAP = {
  INR: { symbol: '₹', locale: 'en-IN', code: 'INR' },
  USD: { symbol: '$', locale: 'en-US', code: 'USD' },
  EUR: { symbol: '€', locale: 'de-DE', code: 'EUR' },
  GBP: { symbol: '£', locale: 'en-GB', code: 'GBP' },
  AED: { symbol: 'AED ', locale: 'ar-AE', code: 'AED' },
  SGD: { symbol: 'S$', locale: 'en-SG', code: 'SGD' },
  AUD: { symbol: 'A$', locale: 'en-AU', code: 'AUD' },
  CAD: { symbol: 'C$', locale: 'en-CA', code: 'CAD' },
  JPY: { symbol: '¥', locale: 'ja-JP', code: 'JPY' },
  CNY: { symbol: '¥', locale: 'zh-CN', code: 'CNY' },
};

export function formatCurrency(amount, currencyCode = 'INR') {
  const curr = CURRENCY_MAP[currencyCode] || CURRENCY_MAP.INR;
  try {
    return new Intl.NumberFormat(curr.locale, {
      style: 'currency',
      currency: curr.code,
      minimumFractionDigits: curr.code === 'JPY' ? 0 : 2,
      maximumFractionDigits: curr.code === 'JPY' ? 0 : 2,
    }).format(amount);
  } catch {
    return `${curr.symbol}${Number(amount).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`;
  }
}

export function getCurrencySymbol(currencyCode = 'INR') {
  return (CURRENCY_MAP[currencyCode] || CURRENCY_MAP.INR).symbol;
}

export function getSupportedCurrencies() {
  return Object.entries(CURRENCY_MAP).map(([code, info]) => ({
    code,
    symbol: info.symbol,
    label: `${info.symbol} ${code}`,
  }));
}

export default CURRENCY_MAP;
